import { Color3 } from '@babylonjs/core/Maths/math';
import find from 'lodash/find';
import { IEnvironmentOptions } from 'sharedtypes/rtx/scenario';

import { EnvironmentList } from '~/Assets/Presets';
import { colorBase255toBase1 } from '~/Utils/color';
import { _environment } from '../studioScene';

export const getEnvTransparent = (): boolean => _environment.getGreyBackground();

export const setVisibleSky = (visibleSky: boolean): void => {
    _environment.setGreyBackground(!visibleSky);
};

export const setFogColor = (color: number[]): void => {
    if (color) {
        _environment.setVisibleSky(true);
        const fixedColor = colorBase255toBase1(color);
        _environment.setFogColor3(new Color3(fixedColor[0], fixedColor[1], fixedColor[2]));
    } else {
        _environment.setGreyBackground(false);
        _environment.setVisibleSky(false);
    }
};

const getPresetOrientation = (): number => {
    const options = _environment.getCurrentOption();
    const { skydiffuse } = options;
    const EnvPreset = find(EnvironmentList, (e) => e.option.skydiffuse === skydiffuse);
    return (EnvPreset) ? EnvPreset.option.lightOrientation.y : 0;
};

let defaultOrientation = 0;
const initDefaultOrientation = () => {
    const options = _environment.getCurrentOption();
    defaultOrientation = options.skyorientation - getPresetOrientation();
};

export const setBackgroundOrientation = (orientation?: number): void => {
    if (orientation === undefined) orientation = defaultOrientation;
    defaultOrientation = orientation;
    const newOrientation = orientation + getPresetOrientation();
    _environment.checkOption({ skyorientation: newOrientation });
};

export const getBackgroundOrientation = (): number => {
    if (!defaultOrientation) initDefaultOrientation();
    return defaultOrientation;
};

export const setSkyBlur = (blur: number): void => {
    _environment.checkOption({ skyblur: blur });
};

export const setSkyBrightness = (brightness: number): void => {
    _environment.checkOption({ skybrightness: brightness });
};

export const setSkyColor = (color: number[]): void => {
    _environment.checkOption({ skycolor: color });
};

export const setGroundVisiblity = (visiblity: number): void => {
    _environment.checkOption({ shadowGroundVisibility: visiblity });
};

export const setShadowSoftness = (softness: number): void => {
    _environment.checkOption({ shadowGroundSoftness: softness });
};

export const setGroundHeight = (height: number): void => {
    _environment.checkOption({ shadowGroundHeight: height });
};

export const getDefaultEnvironment = (): IEnvironmentOptions => _environment.currentValues;

export const checkVisibleSky = (): void => {
    _environment.setGreyBackground(!_environment.currentValues.visibleSky);
};
